import React, { useContext, useEffect, useState } from 'react'
import { ErpClientContext } from '../../services/erp'
import { Form, Table, Input, Button, Space, DatePicker, message } from 'antd'
import { sleep } from '@guillotinaweb/react-gmi'

function formatCurrency(value) {
  return Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
  }).format(value)
}

const initial = {
  monthlyCost: 0,
  date: '',
}

export default function ImportCostWarehouse() {
  const erpService = useContext(ErpClientContext)
  const [columnsTable, setColumnsTable] = useState(null)
  const [data, setData] = useState(null)
  const [state, setState] = useState(initial)
  const [stateImportCost, setStateImportCost] = useState(false)
  const [loading, setLoading] = useState(false)
  const [dataCostes, setDataCostes] = useState(null)

  useEffect(() => {
    init()
  }, [])
  async function init() {
    const res = await erpService.getImportedInvoiceWarehouseCost()

    const columnsAlignRight = [
      'coste_botella',
      'coste_total',
      'coste_total_calculado',
    ]
    console.log(res)
    if (res.status_code === 200 && res.data[0]) {
      setDataCostes(res.data)
      setColumnsTable(
        Object.keys(res.data[0]).map((column) => ({
          title: column.replace(/_/g, ' ').toUpperCase(),
          dataIndex: column,
          columnKey: column,
          sorter:
            column === 'fecha_factura'
              ? (a, b) => new Date(a.fecha_factura) - new Date(b.fecha_factura)
              : column === 'fecha_registro'
              ? (a, b) =>
                  new Date(a.fecha_registro) - new Date(b.fecha_registro)
              : null,
          // filters: column,
          onFilter: column,
          filterSearch: true,
          align: columnsAlignRight.includes(column) ? 'right' : null,
        }))
      )

      const dataColumnsImportedInvoices = res.data.map((dataRes) => {
        return {
          id_coste: dataRes.id_coste,
          fecha_factura: dataRes.fecha_factura,
          fecha_registro: dataRes.fecha_registro,
          numero_botellas: dataRes.numero_botellas,
          numero_pedidos: dataRes.numero_pedidos,
          coste_botella: formatCurrency(dataRes.coste_botella),
          coste_total: formatCurrency(dataRes.coste_total),
          coste_total_calculado: formatCurrency(dataRes.coste_total_calculado),
        }
      })

      setData(dataColumnsImportedInvoices)
    }
  }

  async function getDataCostWarehouse() {
    if (state.monthlyCost === 0 || state.invoiceDate === '') {
      message.error('Invoice cost and date are required.')
      return
    }

    setLoading(true)

    console.log(state)

    const res = await erpService.fetch('/orders/@import-worker-cost-order', {
      method: 'POST',
      body: JSON.stringify({
        date: state.date,
        cost: state.monthlyCost,
      }),
    })

    const response = await res.json()

    if (res.status === 200) {
      message.success('Import order preparation cost correct!')
      await sleep(2000)
      window.location.reload(false)
    } else {
      message.error(response)
    }

    setLoading(false)
  }

  async function recalculateCostsPrepOrders() {
    if (!dataCostes) {
      message.error('No data to recalculate')
      return
    }

    setLoading(true)

    const res = await erpService.fetch(
      '/orders/@recalculate-order-preparation-costs',
      {
        method: 'POST',
        body: JSON.stringify(dataCostes),
      }
    )

    const response = await res.json()

    if (res.status === 200) {
      message.success(
        'Recalculated costs for orders in preparations successfully!'
      )
      await sleep(2000)
      window.location.reload(false)
    } else {
      message.error(`Error ${res.status}: ${response}`)
    }

    setLoading(false)
  }
  return (
    <div
      className="container"
      style={{
        backgroundColor: '#fff',
        padding: '30px',
      }}
    >
      <div className="level-left">
        <h2 className="title is-size-5">
          Import order picking costs warehouse
        </h2>
      </div>

      {stateImportCost ? (
        <Form
          name="import_monthly_cost"
          style={{ maxWidth: 600, marginTop: '20px' }}
          onFinish={getDataCostWarehouse}
        >
          <div>
            <div className="field">
              <label className="label">Enter the invoice number:</label>
              <Form.Item label="Monthly cost" value="monthlyCost">
                <Input
                  placeholder="Input monthly cost"
                  onChange={(e) => {
                    setState({
                      ...state,
                      monthlyCost: e.target.value,
                    })
                  }}
                  rules={[
                    { required: true, message: 'Please input invoice number!' },
                  ]}
                  defaultValue={state.monthlyCost}
                ></Input>
              </Form.Item>
            </div>
            <div className="field">
              <label className="label">Select allocation month:</label>
              <DatePicker
                format={'MM/YYYY'}
                onChange={(date) => {
                  setState({
                    ...state,
                    date: `${date._d.getMonth() + 1}/${date._d.getFullYear()}`,
                  })
                }}
                picker="month"
              />
            </div>
            <Space>
              <Form.Item>
                <Space>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    Submit
                  </Button>
                  <Button
                    type="dashed"
                    htmlType="button"
                    onClick={() => window.location.reload(false)}
                  >
                    Reset
                  </Button>
                </Space>
              </Form.Item>
            </Space>
          </div>
        </Form>
      ) : (
        <div style={{ 'margin-top': '10px' }}>
          <Space>
            <Button
              type="primary"
              onClick={(e) => {
                setStateImportCost(true)
              }}
            >
              Import cost
            </Button>
            <Button onClick={recalculateCostsPrepOrders}>
              Recalculate costs
            </Button>
          </Space>
          <div style={{ 'margin-top': '10px' }}>
            <Table
              columns={columnsTable}
              dataSource={data}
              bordered
              sticky
              scroll={{
                x: true,
                y: true,
              }}
              size="small"
              pagination={false}
            />
          </div>
        </div>
      )}
    </div>
  )
}
